import React, {useEffect, useState} from "react";
import {ProductListFilterItemBoolean} from "@connox/typescript-library";
import {useProductListContext} from "../../ProductListProvider/ProductListProvider";
import {useTranslation} from "react-i18next";
import containerStyles from "../AppToggleContainer/AppToggleContainer.module.scss";
import nlOptionsFormStyles from "../../../newsletter/NewsLetterOptionsForm.module.scss";
import productListFilterstyles from "../ProductListFilter.module.scss";
import {useMediaQuery} from "react-responsive";
import Switch from "react-switch";
import selectStyles from "../../../lib/form/Select/Select.module.scss";
import styles from "./ProductFilterBoolean.module.scss";
import Checkbox from "../../../lib/form/Checkbox/Checkbox";

interface ProductFilterBooleanProps {
  item: ProductListFilterItemBoolean;
  onSelect?: (value: boolean) => void;
}

const ProductFilterBoolean: React.FC<ProductFilterBooleanProps> = ({item, onSelect}) => {
  const {t} = useTranslation();
  const {state, dispatch} = useProductListContext();
  const isMobile = useMediaQuery({query: "(max-width: 480px)"});
  const [isSelected, setIsSelected] = useState<boolean>(false);

  useEffect(() => {
    setIsSelected(!!state.filters[item.field]);
  }, [state.filters[item.field]]);

  const toggleFilter = (checked: boolean) => {
    setIsSelected(checked);
    if (isMobile && onSelect) {
      onSelect(checked);

      return;
    }
    if (checked) {
      dispatch({type: "SET_FILTER", payload: {field: item.field, value: true}});
    } else {
      dispatch({type: "REMOVE_FILTER", payload: {field: item.field}});
    }
  };

  const count = item.values.get(ProductListFilterItemBoolean.trueValueId)?.count ?? 0;
  const title = () => {
    if (count) {
      return (
        <>
          <span className={productListFilterstyles.title} title={`${item.name || t<string>(item.field)}`}>
            {`${item.name || t<string>(item.field)}`}
          </span>
          <span className={productListFilterstyles.count}>{count}</span>
        </>
      );
    }

    return item.name || t<string>(item.field);
  };

  if (!count) {
    return null;
  }

  // desktop view
  if (!isMobile) {
    return (
      <div className={containerStyles.item}>
        <Checkbox
          checked={isSelected}
          color={"#1ba1e2"}
          className={selectStyles.checkbox}
          wrapperClassName={styles.checkboxWrapper}
          onChange={toggleFilter}
        >
          <div className={containerStyles.formElementContentContainer}>{title()}</div>
        </Checkbox>
      </div>
    );
  }

  // mobile view
  return (
    <div className={containerStyles.item}>
      <div
        className={[nlOptionsFormStyles.select, containerStyles.formElementContainer, containerStyles.noArrow].join(
          " ",
        )}
      >
        <div className={containerStyles.formElementContentContainer}>{title()}</div>
        {isMobile && (
          <Switch
            checked={isSelected}
            disabled={!count}
            width={48}
            height={25}
            checkedIcon={false}
            uncheckedIcon={false}
            onColor={"#1ba1e2"}
            offColor={"#999"}
            onChange={toggleFilter}
          />
        )}
      </div>
    </div>
  );
};

export default ProductFilterBoolean;
